<template>
<div class="chapter">
<div class="inner_page">
<section>
<header><h1 class="halftitle" epub:type="title"><span epub:type="pagebreak" id="page_xiii" title="xiii"><i><b>Never in a Hurry</b></i></span></h1></header>
<p class="imaget"><img alt="Image" src="images/cmn1.jpg"/></p>
<p class="halftitle1">Essays on People and Places</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_FM04.vue?3dc408a8